import { Observable } from 'rxjs';
import { Injectable, Optional, SkipSelf } from '@angular/core';
import { CompanyWebTheme } from 'src/lib/fliko/models/company/company.data';
import { Nullish } from 'src/lib/fliko/types/typeish.type';
import { DatabaseService } from 'src/app/shared/services/database.service';
import { FestiveTheme } from './models/context.data';

@Injectable({ providedIn: 'root' })
export class AppThemeService {
  private readonly ROOT = document.documentElement;
  private vars: string[] = [];

  constructor(
    private dbSrv: DatabaseService,
    @Optional() @SkipSelf() thisService?: AppThemeService
  ) {
    if (thisService) throw new Error('Multiple instances of AppThemeService');
  }

  /** @path /webCustomTheme/festiveTheme/ */
  private get festiveTheme() {
    return this.dbSrv.commonFactory.getObject<FestiveTheme>('webCustomTheme/festiveTheme');
  }

  public getFestiveTheme$(): Observable<FestiveTheme | Nullish> {
    return this.festiveTheme.get();
  }

  public getThemeValue(varName: string): string {
    return getComputedStyle(this.ROOT).getPropertyValue(varName);
  }

  public setTheme(theme?: CompanyWebTheme['cssVars'] | null): void {
    this.resetTheme();
    if (!theme) return;
    for (const varName in theme) {
      const value = theme[varName];
      if (!value) continue;
      this.vars.push(varName);
      this.ROOT.style.setProperty(varName, value);
    }
  }

  public resetTheme(): void {
    let varName;
    // prettier-ignore
    while (varName = this.vars.pop()) {
      this.ROOT.style.removeProperty(varName);
    }
  }
}
